const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="mb-12" data-testid="category-filter">
      <h2 className="text-2xl font-semibold text-slate-900 mb-6">Filtrar por categoria</h2>
      <div className="flex flex-wrap gap-3">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onSelectCategory(category)}
            className={`px-6 py-2 rounded-full font-medium text-sm transition-all category-badge ${
              selectedCategory === category
                ? "bg-emerald-900 text-white"
                : "bg-white border border-slate-200 text-slate-700 hover:bg-slate-50"
            }`}
            data-testid={`category-${category.toLowerCase()}`}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;